import Cookies from 'universal-cookie';
import config from 'Config/analytics.json';
import { getDefaultConfig } from 'Utils/Store';

const cookies = new Cookies();
const setCampaignCookie = (data) => {
  const { campaignCookieName, cookieDomain } = getDefaultConfig();
  const options = { path: '/', expires: 0, domain: cookieDomain };
  cookies.set(campaignCookieName, data, options);
};
const getCampaignCookie = () => {
  const { campaignCookieName } = getDefaultConfig();
  return cookies.get(campaignCookieName);
};

const formatTrackingCode = (trackingCodes) => {
  const result = {};
  const params = config.campaignTraits;
  // get the original query string, and replace :: with &
  trackingCodes.forEach((trackingCode) => {
    if (trackingCode !== null) {
      const campaignQueryStr = trackingCode.replace(/::/g, '&');
      const campaignQuery = new URLSearchParams(campaignQueryStr);
      Object.entries(params).forEach(([key, value]) => {
        if (campaignQuery.has(key)) {
          result[value] = campaignQuery.get(key); // populate the results obj
        }
      });
    }
  });
  return result;
};

const createTraitData = (queryStr) => {
  let result = {};
  const params = config.campaignTraits;
  const query = new URLSearchParams(queryStr);

  if (!(query.has('cmpid') || query.has('int_cmpid'))) {
    return result;
  }

  try {
    const genericCampaign = query.get('cmpid');
    const internalCampaign = query.get('int_cmpid');
    result = formatTrackingCode([genericCampaign, internalCampaign]);

    if (genericCampaign) {
      if (genericCampaign.includes('int_org')) {
        result[params.cmpid_int] = genericCampaign;
      } else {
        result[params.cmpid] = genericCampaign;
      }
    }
    if (internalCampaign) {
      result[params.cmpid_int] = internalCampaign;
    }
  } catch (e) {
    return result;
  }
  return result;
};

export const getSessionCampaignTraits = () => {
  let result;

  try {
    result = getCampaignCookie();
    if (window.location.search) {
      // set campaign obj
      const traits = createTraitData(window.location.search);
      setCampaignCookie(traits);
      return traits;
    }
  } catch (e) {
    return {};
  }
  return result;
};
